module.exports = __webpack_public_path__ + "static/media/urg_cbkgc0vp_400x400.0d2ce55c.png";